/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'next-i18next'
import { AdminDeposit } from 'src/core/models'
import { Button, Divider, Tooltip } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import React, { useState, useEffect } from 'react'
import { showNotification } from 'src/core/helpers'
import { DepositsDetailsModal } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  resetCancelDepositState,
  cancelDepositSelector,
  adminDepositsSelector,
  cancelDeposit,
} from 'src/features'

const AdminDepositCancelButton: React.FC<{ deposit: AdminDeposit }> = ({ deposit }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { data: depositList } = useAppSelector(adminDepositsSelector)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { loading, success, currentDepositId } = useAppSelector(cancelDepositSelector)
  const isLoading = loading && currentDepositId === deposit.id

  useEffect(() => {
    if (success && currentDepositId === deposit.id) {
      dispatch(resetCancelDepositState())
      showNotification('success', t('ValidateDeposits.Cancelled'))
      setIsModalVisible(false)
    }
  }, [success])

  return <>
    <Tooltip title={t('ValidateDeposits.Cancel')} color={'blue'}>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        className={`radius-100 ml-3`}
        onClick={() => setIsModalVisible(true)}
        icon={<DeleteOutlined/>}
      />
    </Tooltip>

    <DepositsDetailsModal
      showHeaderLabel={false}
      modalTitle={t('ValidateDeposits.SureCancel')}
      isModalVisible={isModalVisible}
      handleCancel={() => setIsModalVisible(false)}
      deposit={{
        currency_token_id: deposit.currency_token_id,
        amount: deposit.total,
        internal_reference: deposit.internal_reference
      }}
      footerContent={<div className='mt-4'>
        <Divider />
        <Button
          danger
          block
          size='large'
          loading={isLoading}
          disabled={isLoading}
          className='radius-100'
          onClick={() => dispatch(cancelDeposit(deposit.id, depositList))}
        >{isLoading ? t('ValidateDeposits.Cancelling') : t('ValidateDeposits.Cancel')}
        </Button>
      </div>}
    />
  </>
}

export default AdminDepositCancelButton
